export default __webpack_public_path__ + "static/media/pr-flag.f4a25fef.svg";